import { CardProtectionCoverage } from "src/containers/card-protection/domain/coverage";
import { ReactComponent as InternetFraudIcon } from "src/assets/icons/proteccion-tarjeta/icon_compras_internet.svg";
import { ReactComponent as RobberyIcon } from "src/assets/icons/hogar/icon_robo.svg";
import { ReactComponent as UnknownWithdrawIcon } from "src/assets/icons/proteccion-tarjeta/icon_retiro_no_reconocido.svg";
import { ReactComponent as UnknownTransferIcon } from "src/assets/icons/proteccion-tarjeta/icon_transferencia_no_reconocida.svg";

const coverages = [
    {
        id: "compras-no-reconocidas",
        title: "Compras no reconocidas en locales comerciales",
        shortTitle: "Compras no reconocidas",
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Un extraño ha realizado compras con mis tarjetas BCP en
                    establecimientos comerciales.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Robo o asalto
                    </div>
                    <div className="coverage-content__text bullet">Pérdida</div>
                    <div className="coverage-content__text bullet">Hurto</div>
                    <div className="coverage-content__text bullet">
                        Cambiazo
                    </div>
                    <div className="coverage-content__text bullet">
                        Secuestro
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documento que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "retiro-dinero-no-reconocido",
        title: "Retiro de dinero no reconocido en cajeros",
        shortTitle: "Retiro de dinero no reconocido",
        icon: <UnknownWithdrawIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Un extraño ha retirado dinero de mis tarjetas BCP de un
                    cajero.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Secuestro
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documento que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "robo-dinero-retirado",
        title: "Robo de dinero retirado por cajero o agente BCP",
        shortTitle: "Robo de dinero retirado",
        icon: <RobberyIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Retiré dinero de mi tarjeta BCP de un cajero o agente, y al
                    salir me robaron.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Robo o asalto
                    </div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "transferencias-no-reconocidas",
        title: "Transferencias no reconocidas por canales virtuales BCP",
        shortTitle: "Transferencias no reconocidas",
        icon: <UnknownTransferIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Un extraño ha realizado transferencias a través de Yape,
                    banca móvil y/o banca por internet sin mi consentimiento.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Robo o asalto
                    </div>
                    <div className="coverage-content__text bullet">Pérdida</div>
                    <div className="coverage-content__text bullet">Hurto</div>
                    <div className="coverage-content__text bullet">
                        Cambiazo
                    </div>
                    <div className="coverage-content__text bullet">
                        Secuestro
                    </div>
                    <div className="coverage-content__text bullet">Fraude</div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                </div>
            </>
        ),
    },
    {
        id: "compras-no-reconocidas-internet",
        title: "Transferencias no reconocidas por canales virtuales BCP",
        shortTitle: "Compras no reconocidas por internet",
        icon: <InternetFraudIcon />,
        content: (
            <>
                <div className="coverage-content__section coverage-content__text">
                    Un extraño ha realizado compras por internet con mis
                    tarjetas BCP sin mi consentimiento.
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    A consecuencia de:
                </div>
                <div className="coverage-content__section">
                    <div className="coverage-content__text bullet">
                        Robo o asalto
                    </div>
                    <div className="coverage-content__text bullet">Pérdida</div>
                    <div className="coverage-content__text bullet">Hurto</div>
                    <div className="coverage-content__text bullet">
                        Cambiazo
                    </div>
                    <div className="coverage-content__text bullet">
                        Secuestro
                    </div>
                    <div className="coverage-content__text bullet">Fraude</div>
                </div>
                <div className="coverage-content__section coverage-content__text highlight text-bold">
                    Documentos que necesitas para hacer uso de tu seguro:
                </div>
                <div className="coverage-content__section tabbed">
                    <div className="coverage-content__text bullet">
                        Denuncia Policial
                    </div>
                </div>
            </>
        ),
    },
] as CardProtectionCoverage[];

export default coverages;
